import Enum from 'enum';

export const Manufacturers = new Enum([
    'Plantronics',
    'EPOS',
    'Jabra4',
    'Yealink',
]);

export const PLUGIN_NAME = 'tvx_flowapp';
